import { Helmet } from "react-helmet-async"
import Contact from "../components/Contact/Contact"

export default function ContactUs() {
    const schema = {
        "@context": "https://schema.org",
        "@type": "Event",
        "name": "Contact Salusion | HRA Administration Software | Speak with an HRA Expert",
        "description": "Get in touch with Salusion about HRA Administration Software. Our experts help small businesses with ICHRA, QSEHRA options",
        "startDate": "2025-06-01T09:00:00-04:00", // REQUIRED: Example start date and time (adjust for actual earliest slot)
        "endDate": "2026-12-31T17:00:00-04:00",   // REQUIRED: Example end date and time (adjust for actual latest slot or end of availability)
        "eventStatus": "https://schema.org/EventScheduled", // RECOMMENDED: Indicates it's a scheduled event
        "eventAttendanceMode": "https://schema.org/OnlineEventAttendanceMode", // RECOMMENDED: Indicates it's an online event
        "location": {
            "@type": "VirtualLocation", // Recommended for online events
            "url": "https://calendly.com/salusion-inquiry/salusion-support" // The URL of the virtual meeting
        },
        "performer": {
            "@type": "Person",
            "name": "Salusion Expert",
            "url": "https://salusion.com"
        },
        "organizer": { // RECOMMENDED: Who is organizing the event
            "@type": "Organization",
            "name": "Salusion, Inc.",
            "url": "https://salusion.com"
        },
        "offers": { // RECOMMENDED: How to access/book the event
            "@type": "Offer",
            "url": "https://calendly.com/salusion-inquiry/salusion-support",
            "price": "0", // Assuming consultation is free
            "priceCurrency": "USD",
            "availability": "https://schema.org/InStock", // Indicates it's available for booking
            "validFrom": "2024-09-01T00:00:00Z" // When the offer becomes valid (e.g., when booking opens)
        }
    }

    return (
        <>
            <Helmet>
                <title>Contact Salusion | HRA Administration Software | Speak with an HRA Expert</title>
                <meta name="title" content="Contact Salusion | HRA Administration Software | Speak with an HRA Expert" />
                <meta name="description" content="Get in touch with Salusion about HRA Administration Software. Our experts help small businesses with ICHRA, QSEHRA options" />
                <meta name="keywords" content="HRA consultation, health reimbursement arrangement, business HRA, free consultation, Salusion, HRA setup, HRA management" />
                <link rel="canonical" href="https://salusion.com/contact-us" />

                <meta name="twitter:card" content="summary_large_image" />
                <meta name="twitter:site" content="@Salusion" />
                <meta name="twitter:title" content="Contact Salusion | HRA Administration Software | Speak with an HRA Expert" />
                <meta name="twitter:description" content="Get in touch with Salusion about HRA Administration Software. Our experts help small businesses with ICHRA, QSEHRA options" />
                <meta name="twitter:image" content="https://salusion.com/assets/images/Generic.png" />
                <meta name="twitter:image:alt" content="Illustration of a hand offering money to another hand, representing health reimbursement benefits or a consultation." />

                <meta property="og:title" content="Contact Salusion | HRA Administration Software | Speak with an HRA Expert" />
                <meta property="og:description" content="Get in touch with Salusion about HRA Administration Software. Our experts help small businesses with ICHRA, QSEHRA options" />
                <meta property="og:image" content="https://salusion.com/assets/images/Generic.png" />
                <meta property="og:url" content="https://salusion.com/contact-us" />
				<meta property="og:type" content="website" />
				<meta property="og:site_name" content="Salusion" />
				<meta property="og:locale" content="en_US" />

                <script type="application/ld+json">{JSON.stringify(schema)}</script>
            </Helmet>
            <Contact />
        </>
    )
}
